import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router-dom';

import Breadcrumbs from '../../breadcrumbs';

import CommonNewsDetail from '../../news/common-detail';

class ProjectsDetail extends Component {
  render() {
    return(
      <CommonNewsDetail>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/infocenter">Інфоцентр</Link></li>
          <li><Link to="/infocenter/projects">Проекти та програми</Link></li>
          <li><Link to={`/infocenter/projects/detail/${this.props.match.params.id}`}>Новина № {this.props.match.params.id}</Link></li>
        </Breadcrumbs>
      </CommonNewsDetail>
    )
  }
}

export default withRouter(ProjectsDetail);



// WEBPACK FOOTER //
// ./src/system/information-center/projects/detail.js